// extracted by mini-css-extract-plugin
module.exports = {"ImgCropped":"mq_a pz_a pz_q pz_ru","ImgCropped__img":"mq_b pz_a","ImgCropped--y_center":"mq_c pz_j","ImgCropped--y_top":"mq_e pz_k","ImgCropped--y_bottom":"mq_f pz_l"};